import fetch from 'utils/fetch';
import { serializeFunnel } from 'funnel/utils/serialize';

export const REQUEST_FUNNEL = 'REQUEST_FUNNEL';
export const RECEIVE_FUNNEL = 'RECEIVE_FUNNEL';
export const FUNNEL_RECEIVE_FAILED = 'FUNNEL_RECEIVE_FAILED';
export const SAVING_FUNNEL = 'SAVING_FUNNEL';
export const FUNNEL_SAVE_FAILED = 'FUNNEL_SAVE_FAILED';

function requestFunnel(funnel) {
  return {
    type: REQUEST_FUNNEL,
    payload: {
      funnel,
    },
  };
}

function receiveFunnel(funnel, products) {
  return {
    type: RECEIVE_FUNNEL,
    payload: {
      funnel,
      products,
    },
  };
}

function receiveFailed(error) {
  return {
    type: FUNNEL_RECEIVE_FAILED,
    payload: {
      error,
    },
  };
}

function savingFunnel(funnel) {
  return {
    type: SAVING_FUNNEL,
    payload: {
      funnel,
    },
  };
}

function saveFailed(error) {
  return {
    type: FUNNEL_SAVE_FAILED,
    payload: {
      error,
    },
  };
}

function fetchFunnel(funnel) {
  return dispatch => {
    dispatch(requestFunnel(funnel));
    fetch(`/funnels.json/${funnel}`)
      .then(r => r.json())
      .then(({ funnel, products }) => dispatch(receiveFunnel(funnel, products)))
      .catch(error => dispatch(receiveFailed(error)));
  };
}

function shouldFetchFunnel(state) {
  const funnel = state.funnels.funnel;
  if (!funnel.funnel) {
    return true;
  } else if (funnel.isFetching) {
    return false;
  }

  return funnel.didInvalidate;
}

export function fetchFunnelIfNeeded(funnel) {
  return (dispatch, getState) => {
    if (shouldFetchFunnel(getState())) {
      dispatch(fetchFunnel(funnel));
    }
  };
}

export function saveFunnel(id, fields) {
  return (dispatch, getState) => {
    const state = getState().funnels;
    const funnelAsMultipart = serializeFunnel(state, fields);

    dispatch(savingFunnel(id));
    return fetch(`/funnels.json/${id}`, {
      method: 'post',
      body: funnelAsMultipart,
    })
      .then(res => res.json())
      .then(updated =>
        dispatch(receiveFunnel(updated, state.products.items.toArray()))
      )
      .catch(error => dispatch(saveFailed(error)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/funnel.js